const TOKEN_KEY = 'elfreports.backoffice.token'
const USER_KEY = 'elfreports.backoffice.user'
const EXPIRES_AT_KEY = 'elfreports.backoffice.expires_at'

function getStorage() {
  if (typeof window === 'undefined') {
    return null
  }

  return window.sessionStorage
}

export function getStoredToken() {
  return getStorage()?.getItem(TOKEN_KEY) || ''
}

export function getStoredUser() {
  const raw = getStorage()?.getItem(USER_KEY)
  if (!raw) {
    return null
  }

  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function getStoredExpiresAt() {
  return getStorage()?.getItem(EXPIRES_AT_KEY) || null
}

export function isStoredSessionExpired(expiresAt = getStoredExpiresAt()) {
  if (!expiresAt) {
    return false
  }

  const timestamp = Date.parse(expiresAt)
  if (Number.isNaN(timestamp)) {
    return false
  }

  return timestamp <= Date.now()
}

export function storeAuthSession({ token, user, expiresAt }) {
  const storage = getStorage()
  if (!storage) {
    return
  }

  storage.setItem(TOKEN_KEY, token)
  storage.setItem(USER_KEY, JSON.stringify(user || null))
  if (expiresAt) {
    storage.setItem(EXPIRES_AT_KEY, expiresAt)
  } else {
    storage.removeItem(EXPIRES_AT_KEY)
  }
}

export function clearAuthSession() {
  const storage = getStorage()
  if (!storage) {
    return
  }

  storage.removeItem(TOKEN_KEY)
  storage.removeItem(USER_KEY)
  storage.removeItem(EXPIRES_AT_KEY)
}
